import { createContext } from "react"
import { Outlet } from "react-router-dom"

export type TenantFeatures = {
  site_reservation?: Boolean
  customer_advanced?: Boolean
  customer_reporting?: Boolean
  servicing?: Boolean
  plan_with_ai?: Boolean
  asset_forecast?: Boolean
  asset_forecast_debug?: Boolean
  installation_forecast?: Boolean
  calendar_sites?: Boolean
  system_node_graphs?: Boolean
  system_node_v2?: Boolean
  asset_depletion?: Boolean
  user_reports?: Boolean
  orders_activityless?: Boolean
  demo_dashboard_vmi?: Boolean
  hide_reports_asset?: boolean
  hide_reports_system?: boolean
  // AC Load Assets can be created. Off in production until Load Precedence is live
  // end to end (docs/assets/ac-load-component/STATUS.md).
  ac_load?: boolean
}

type ContextState = {
  features?: TenantFeatures
}

export const FeaturesContext = createContext<ContextState | undefined>(undefined)

export const FeaturesProvider = ({ features, children }: { features?: TenantFeatures; children?: React.ReactNode }) => {
  const value = {
    features,
  }


  return <FeaturesContext.Provider value={value}>{children ? children : <Outlet />}</FeaturesContext.Provider>
}
